var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"iframe-box"}},[(_vm.pid)?_c('p',[_vm._v("PID: "+_vm._s(_vm.pid))]):_vm._e(),(_vm.uri)?_c('iframe',{attrs:{"src":_vm.uri}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }